import React from 'react';
import $ from "jquery";
import Quill from 'quill';

export default class RichTextInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      object: this.props.object,
      properties: this.props.properties,
    };
  }

  handleChange = (e) => {
    let object = e;
    this.setState({object: object});
    this.props.onChange(this.props.objectKey, object);
  }

  componentWillReceiveProps = (props) => {
    if (typeof props.object !== "undefined" && props.object !== null) {
      this.setState({object: props.object});
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    this.updateJSElements();
  }

  componentDidMount = () => {
    this.updateJSElements();
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (this.props.disabled !== nextProps.disabled) {
      return true;
    }
    if (!this.state.object) {
      return true;
    }
    this.state.object = nextState.object; // eslint-disable-line
    return false;
  }

  updateJSElements = () => {
    var container = $('div[data-key='+this.props.objectKey+']');
    container.parent().children().each((i, obj) => {
      if (obj !== container.get(0)) {
        $(obj).remove();
      }
    });
    container.html(this.state.object);
    var imageHandler = () => {
      var range = this.quill.getSelection();
      var value = prompt('Please enter global image URL:');
      if (value) {
        this.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
      }
    }
    var colors = [
      "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff",
      "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb",
      "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888",
      "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444",
      "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", "#000000",
      "#c43a87"
    ];
    var toolbarOptions = [
      [{ 'font': [] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['link', 'image', 'video'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
      [{ 'color': colors }, { 'background': colors }],          // dropdown with defaults from theme
      [{ 'align': [] }],
      ['clean']                                         // remove formatting button
    ];
    var quill = new Quill(container.get(0), {
      modules: {
        toolbar: this.props.disabled ? null : toolbarOptions,
      }, 
      theme: 'snow',
      bounds: container[0],
      readOnly: this.props.disabled 
    });
    if (!this.props.disabled) {
      quill.getModule('toolbar').addHandler('image', imageHandler);
    }
    quill.on('text-change', () => {
      this.state.object = container.find(".ql-editor").html(); // eslint-disable-line
      this.props.onChange(this.props.objectKey, container.find(".ql-editor").html());
    });
  }

  render = () => {
    return (
      <div 
        className={this.props.disabled ? "disabled" : ""}
        data-key={this.props.objectKey} 
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/RichTextInput.js